// extracted by mini-css-extract-plugin
export default {"heading":"pU","container":"qU","product_section_row":"rU","carousel":"sU","carouselwide":"tU","carouselwrapper":"uU","blockwrapper":"vU","product_carousel_row":"wU","headingnarrow":"xU","title":"yU"};
    if(module.hot) {
      // 1737143663338
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  